import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/recordings")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
